import Flickity from "flickity";

export function init() {
	const boatshows = Array.from(document.querySelectorAll(".c-boat-slideshow"));
	boatshows.forEach((element) => create(element));
}

export function create(element) {
	let options = {};
	let optionsString = element.getAttribute("data-slideshow");

	if (optionsString) {
		options = JSON.parse(optionsString);
	}

	let defaults = {
		accessibility: true,
		prevNextButtons: true,
		pageDots: true,
		setGallerySize: false,
		imagesLoaded: true,
		arrowShape: "M30.7,20.3l-29.3,30l29.3,30 M100.7,50.3H1.4",
	};

	return new Flickity(element, { ...defaults, ...options });
}
